export const banksInfo = [
  { name: 'Banco de Venezuela', value: 'Banco de Venezuela', code: '0102' },
  {
    name: 'Venezolano de Crédito',
    value: 'Venezolano de Crédito',
    code: '0104',
  },
  { name: 'Mercantil', value: 'Mercantil', code: '0105' },
  { name: 'Provincial', value: 'Provincial', code: '0108' },
  { name: 'Bancaribe', value: 'Bancaribe', code: '0114' },
  { name: 'Exterior', value: 'Exterior', code: '0115' },
  {
    name: 'Occidental de Descuento',
    value: 'Occidental de Descuento',
    code: '0116',
  },
  { name: 'Banco Caroní', value: 'Banco Caroní', code: '0128' },
  { name: 'Banesco', value: 'Banesco', code: '0134' },
  { name: 'Banco Plaza', value: 'Banco Plaza', code: '0138' },
  { name: 'Banco Sofitasa', value: 'Banco Sofitasa', code: '0137' },
  {
    name: 'BFC Banco Fondo Común',
    value: 'BFC Banco Fondo Común',
    code: '0151',
  },
  { name: '100% Banco', value: '100% Banco', code: '0156' },
  { name: 'Del Sur', value: 'Del Sur', code: '0157' },
  { name: 'Banco del Tesoro', value: 'Banco del Tesoro', code: '0163' },
  {
    name: 'Banco Agrícola de Venezuela',
    value: 'Banco Agrícola de Venezuela',
    code: '0166',
  },
  { name: 'Bancrecer', value: 'Bancrecer', code: '0168' },
  { name: 'Mi Banco', value: 'Mi Banco', code: '0169' },
  { name: 'Bancamiga', value: 'Bancamiga', code: '0172' },
  { name: 'Banplus', value: 'Banplus', code: '0174' },
  {
    name: 'Bicentenario del Pueblo',
    value: 'Bicentenario del Pueblo',
    code: '0175',
  },
  { name: 'Banfanb', value: 'Banfanb', code: '0177' },
  {
    name: 'BNC Nacional de Crédito',
    value: 'BNC Nacional de Crédito',
    code: '0191',
  },
  {
    name: 'Banco de la Gente Emprendedora',
    value: 'Banco de la Gente Emprendedora',
    code: '0146',
  },
  {
    name: 'DelSur Banco Universal',
    value: 'DelSur Banco Universal',
    code: '0157',
  },
  {
    name: 'Banco Activo',
    value: 'Banco Activo',
    code: '0171',
  },
  {
    name: 'Banco Internacional de Desarrollo',
    value: 'Banco Internacional de Desarrollo',
    code: '0173',
  },
  {
    name: 'Banplus',
    value: 'Banplus',
    code: '0174',
  },
  {
    name: 'Banco Bicentenario',
    value: 'Banco Bicentenario',
    code: '0175',
  },
  {
    name: 'Banco de Exportación y Comercio',
    value: 'Banco de Exportación y Comercio',
    code: '0177',
  },
  {
    name: 'Citibank',
    value: 'Citibank',
    code: '0190',
  },
];

export function searchBankNameByCode(code: string) {
  return banksInfo.find((bank) => bank.code === code)?.name;
}
